import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for registering and managing accounts
 */
const create = () => { 

    const api = BaseApi.create();

    const checkForExistingAccount = () => api.get(ApiPaths.ACCOUNT);

    const createNewAccount = (accountId, accountData, creds, locale) => {
        var payload = {
            FirstName: accountData.firstName,
            LastName: accountData.lastName,
            Email: accountData.email,
            PhoneNumber: accountData.mobilePhone,
            PhoneTypeId: accountData.phoneType,
            Password: creds ? creds.password.value : null,
            Question: creds ? creds.questionIndex + 1 : -1,
            Province: accountData.province,
            Answer: creds ? creds.answer : null,
            Hint: creds ? creds.hint : null,
            LanguagePreference: locale && locale === 'fr' ? "fr-CA" : "en-US",
            ContactConsent: accountData.consentChecked
        }
        if (accountId) {
            payload.AccountId = accountId
        }

        return api.post(ApiPaths.ACCOUNT, JSON.stringify(payload))
    }

    const accountSignIn = (email, password) => {
        var payload = {
            "Email": email,
            "Password": password
        }
        return api.post(ApiPaths.ACCOUNT_SIGNIN, payload)
    }

    const refreshAccessToken = () => api.post(ApiPaths.ACCOUNT_REFRESH_TOKEN, '');

    const createCase = () => {
        // by not specifying a list of tax years, the server will create one for the current year
        var payload = {
            taxYears: [],
            directCode: localStorage.getItem('va_direct_code')
        }
        return api.post(ApiPaths.CASE, payload)
    }

    const createConversation = () => api.post(ApiPaths.ACCOUNT_CONVERSATION, '');
    const saveLanguagePref = (langPref) => api.post(ApiPaths.ACCOUNT_LANGUAGE(langPref), null);
    const addvarole = (email, password) => {
        var payload = {
            "Email": email,
            "Password": password
        }
        return api.post(ApiPaths.ACCOUNT_ADDVAROLE, payload)
    }

  // Return back a collection of functions
  return {
      checkForExistingAccount, createNewAccount, accountSignIn, createCase, createConversation,
      saveLanguagePref, addvarole, refreshAccessToken
  }
}

// let's return back our create method as the default.
export default {
  create
}